import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17fd3bd0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-container d-flex" }
const _hoisted_2 = ["src"]

import { computed, ref, Ref } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'BannerComponent',
  props: {
    imageSrc: {},
    heading: {},
    subheading: {},
    bannerHeadingColor: {},
    isOverlay: { type: Boolean },
    isHeadingRight: { type: Boolean },
    isLowOpacity: { type: Boolean },
    alignRight: { type: Boolean }
  },
  setup(__props: any) {

  const props = __props;

  const opacityStyle = computed(() => {
    return props.isLowOpacity ? { opacity: '0.65' } : {};
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["image-container", _ctx.isOverlay ? 'image-container-overlay' : 'image-container-none-overlay']),
      style: _normalizeStyle(!_ctx.alignRight ? opacityStyle.value : 'opacity: 0.5')
    }, [
      _createElementVNode("img", {
        src: require(`@/assets/${_ctx.imageSrc}`),
        alt: "Banner Image",
        class: "main-img"
      }, null, 8, _hoisted_2)
    ], 6),
    _createElementVNode("div", {
      class: _normalizeClass(["heading-container", [_ctx.isOverlay ? 'heading-container-shadow' : 'heading-container', _ctx.alignRight ? 'title-right' : '']])
    }, [
      _createElementVNode("div", {
        style: _normalizeStyle({color: _ctx.bannerHeadingColor}),
        class: _normalizeClass(_ctx.isHeadingRight ? 'heading-main-is-right' : 'heading-container-main')
      }, _toDisplayString(_ctx.heading), 7),
      _createElementVNode("div", {
        class: "heading-container-sub",
        style: _normalizeStyle({color: _ctx.bannerHeadingColor})
      }, _toDisplayString(_ctx.subheading), 5)
    ], 2)
  ]))
}
}

})